import { render, staticRenderFns } from "./BankBranchList.vue?vue&type=template&id=893e2ed8"
import script from "./BankBranchList.vue?vue&type=script&lang=js"
export * from "./BankBranchList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports